// src/pages/Public/LandingPage/v2/components/AwardSection/AwardSection.js
//
// Seccion de reconocimiento (SilverEco International Awards). Aparece entre ValueProp y
// el CTA. Imagen del premio a la izquierda + textos (i18n) a la derecha, en una tarjeta.

import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

export function AwardSection({ awardSrc }) {
  const { t } = useLandingLang();

  return (
    <section className="py-24 px-6 bg-slate-50 border-b border-slate-100">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white rounded-[2.5rem] border border-slate-100 shadow-xl p-8 lg:p-12 flex flex-col lg:flex-row items-center gap-10 hover:shadow-2xl transition-all duration-500 group">
          {/* Imagen del premio */}
          {awardSrc ? (
            <div className="shrink-0 w-full lg:w-56 flex items-center justify-center">
              <img
                src={awardSrc}
                alt={t("awardTitle")}
                className="w-44 lg:w-full h-auto object-contain transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </div>
          ) : null}

          {/* Textos */}
          <div className="flex-1 text-center lg:text-left space-y-3">
            <span className="text-rose-500 !font-black tracking-widest uppercase text-xs">
              {t("awardTag")}
            </span>
            <h3 className="text-2xl lg:text-3xl !font-black tracking-tight text-slate-800">
              {t("awardTitle")}
            </h3>
            <p className="text-slate-500 font-medium leading-relaxed">
              {t("awardCategory")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
